export default "__VITE_ASSET__CZU5Oz6i__"